export default {
  "hierarchy": {
    "mobileItemScreen": [
      "breadcrumbs-mobileItemScreen"
    ],
    "topNavBreadcrumbs": [
      "breadcrumbs-topNavBreadcrumbs"
    ],
    "mobileTopNavBreadcrumbs": [
      "breadcrumbs-topNavBreadcrumbs",
      "breadcrumbs-mobileTopNavBreadcrumbs"
    ]
  },
  "props": {
    "default": {
      "separator": "|"
    },
    "mobileItemScreen": {
      "separator": " "
    },
    "topNavBreadcrumbs": {
      "separator": "|",
      "separatorIcon": "fa fa-chevron-right"
    },
    "mobileTopNavBreadcrumbs": {
      "separator": "|",
      "separatorIcon": "fa fa-chevron-right"
    }
  }
}